import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';

import './side-panel-action-button.scss';

export function SidePanelActionButton({
  icon = null,
  label,
  onClick = noop,
  trackingId = null,
  trackingValue = null,
  buttonClassNames = '',
  iconWidth = 16,
  iconElement = null,
  hoverCopy = null,
  hoverCopyTextClassName = 'text-cool-gray-100',
  hoverContent = null,
  popoverClassName = undefined,
  popoverContainerClassName = undefined,
}) {
  const renderButton = (targetProps = {}, targetRef) => (
    <Button
      {...targetProps}
      aria-label={label}
      color="link"
      onClick={onClick}
      innerRef={targetRef}
      className={classnames(
        'side-panel-action-button d-flex align-items-center p-0 text-decoration-none pos-r rounded-20 overflow-hidden text-nowrap border-0 z-3',
        buttonClassNames
      )}
      {...(trackingId ? { 'data-tracking-id': trackingId } : {})}
      {...(trackingValue ? { 'data-tracking-value': trackingValue } : {})}
    >
      <span className="icon-wrap d-flex align-items-center justify-content-center flex-shrink-0">
        {iconElement || <img src={icon} width={iconWidth} alt="" className="text-white" />}
      </span>
      {hoverCopy && (
        <span
          className={classnames(
            'hover-copy fw-medium text-transform-none ms-0_5 pe-0_75 size-14',
            hoverCopyTextClassName
          )}
        >
          {hoverCopy}
        </span>
      )}
    </Button>
  );

  if (!hoverContent) {
    return renderButton();
  }

  return (
    <PopoverItem
      className={classnames('side-panel-action-button-wrapper pos-r', popoverContainerClassName)}
      screenReaderTooltipLabel={label}
      placement="top-start"
      trigger="hover focus click"
      delay={{ show: 0, hide: 200 }}
      offset={[0, 18]}
      fade={false}
      popoverClassName={popoverClassName}
      popperClassName="rounded-12"
      hideArrow
      innerClassName="d-flex flex-column pos-r bg-white rounded-12"
      renderTarget={(targetProps, targetRef) => renderButton({ ...targetProps, onKeyDown: noop }, targetRef)}
    >
      {hoverContent}
    </PopoverItem>
  );
}

SidePanelActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  trackingId: PropTypes.string,
  icon: PropTypes.string,
  trackingValue: PropTypes.string,
  buttonClassNames: PropTypes.string,
  iconWidth: PropTypes.number,
  iconElement: PropTypes.node,
  hoverCopy: PropTypes.string,
  hoverCopyTextClassName: PropTypes.string,
  hoverContent: PropTypes.node,
  popoverClassName: PropTypes.string,
  popoverContainerClassName: PropTypes.string,
};
